import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function CVHeader({ menuItems }) {
  return (
    <Box
      sx={{
        height: "90px",
        width: "100%",
        bgcolor: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        px: 2,
      }}
    >
      {/* Title and Subheading on the Left */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="h6"
          component="h1"
          sx={{
            fontFamily: "Readex Pro",
            fontWeight: 500,
            fontStyle: "normal",
            fontSize: "30px",
            lineHeight: "38px",
            letterSpacing: "0%",
          }}
        >
          CV Builder
        </Typography>
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{
            fontFamily: "Readex Pro",
            fontWeight: 300,
            fontStyle: "normal",
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0%",
          }}
        >
          Create a professional CV in minutes
        </Typography>
      </Box>

      {/* Menu Items Component in the Middle */}
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
        {menuItems}
      </Box>

      {/* Empty Box to Balance Flex Layout */}
      <Box sx={{ flex: 1 }} />
    </Box>
  );
}

CVHeader.propTypes = {
  chipLabel: PropTypes.string,
  menuItems: PropTypes.element.isRequired,
};